/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import useConfig from "../../../actions/Tenants/config/configHook";
import { useUserPreferences } from "../../../hooks";
import { getFilledArrayOrDefault } from "../../../utils";
import SingleSelect from "../../Forms/SingleSelect";

export default function FruitFilter() {
    const config = useConfig();
    const [userPreferences, updatePreferences] = useUserPreferences();

    return (
        <div css={css`
            width: 20rem;
            z-index: 1000;
            @media (max-width: 992px) {
                width: 100%;
                min-width: 15rem;
            }
        `} className="mb-n3">

            <SingleSelect
                options={config.get_fruit_types().map(({ value, text }) => ({ value, label: text }))}
                field="fruit_types"
                setValue={(_, value) => updatePreferences({ fruit_types: getFilledArrayOrDefault(value as string[]) })}
                post_value={userPreferences.fruitTypes}
                label={false}
                multi={true}
                isClearable={true}
                return_array={true}
                placeholder="Select fruit"
            />
        </div>
    );
}
